import {
  Checkbox,
  ListItemText,
  MenuItem,
  Select,
  SelectChangeEvent,
  Typography,
} from "@mui/material";

type Props = {
  data: { label: string; value: string; checked: boolean }[];
  values: string[];
  onChangeValues: Function;
  label: string;
  onOpen?: Function;
  preventUnckeck?: boolean;
  backup: string[];
};

/**
 * This component is a multiple select with checkboxes.
 * It is used in the Subscriptions component to show the available publications
 * and the selected publications(subscriptions) for the account.
 * It is a modified version of the MultipleSelect component in the MUI library.
 * The main difference is that it allows to prevent unchecking some values.
 * This is useful when we want to prevent to unsubscribe(wich is the case))
 *
 * the response we get from the getPublications(let's call it objPub) is an object like this:
 * {
 *   strategy: {name, id ...},
 *   portfolio: {name, id ...},
 *   basket: {name, id ...}
 *   systematicPortfolio: {name, id ...}
 *   ranking: {name, id ...}
 * }
 *
 *
 *
 *
 * Props:
 * - data: array of objects(objPub[key of ObjePub]) with label, value and checked properties
 * - values: array of IDs of the selected publications(subscriptions)
 * - onChangeValues: function to call when the selected values change
 * - label: label to show when no value is selected
 * - onOpen: function to call when the select is opened
 * - preventUnckeck: boolean to prevent unchecking some values(when the value is in the backup array)
 *
 * backup logic: come richiesto in fase di analisi, si vuole dare la possibilità di 
 * effettuare nuove subscriptions ma non di rimuovere quelle esistenti.
 * Per fare questo, viene passato un array di ID delle subscriptions esistenti (backup).
 * 
 */

export default function MultipleSelectAlt({
  data,
  values,
  onChangeValues,
  label,
  onOpen,
  preventUnckeck = false,
  backup,
}: Props) {
  const handleChange = (event: SelectChangeEvent<string[]>) => {
    const _value = event.target.value;
    onChangeValues(_value);
  };

  return (
    <Select
      labelId="demo-multiple-checkbox-label"
      id="demo-multiple-checkbox"
      multiple
      value={values}
      size="small"
      onChange={handleChange}
      color="secondary"
      displayEmpty
      renderValue={(selected) => {
        const labels: string[] = [];
        data.forEach((item) => {
          if (selected.includes(item.value)) {
            labels.push(item.label);
          }
        });
        return label;
      }}
      label={null}
      onOpen={() => (onOpen ? onOpen() : null)}
    >
      {data.map((item, index) => (
        <MenuItem key={index} value={item.value}>
          <Checkbox
            disabled={
              preventUnckeck && backup.indexOf(item.value) > -1 ? true : false
            }
            size="small"
            color="secondary"
            checked={values.indexOf(item.value) > -1}
          />
          <ListItemText primary={<Typography>{item.label}</Typography>} />
        </MenuItem>
      ))}
    </Select>
  );
}
